import React from 'react';

const Logo = () => {
  return <img src={require('../assets/images/company_logo.png')} alt="" height="50" width="80"/>
};

export default Logo;
